import connector from "service/connector"
import utils from "utils";


const getBoard = async data => await
  connector.connectFetchController(`board${data ? "?" + utils.etc.getFilterStr(data) : ""}`, "GET");


export { getBoard };
export default { getBoard };